
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcCheckbox as ObcCheckboxElement} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
 import {ObcCheckboxChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
 export type {ObcCheckboxChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/checkbox/checkbox.js';
 

 
 export const ObcCheckbox = createComponent({
   react: React,
   tagName: 'obc-checkbox',
   elementClass: ObcCheckboxElement,
   events: {
     
     onChange: 'change' as EventName<ObcCheckboxChangeEvent>,
     onDisabled: 'disabled' as EventName<ObcCheckboxChangeEvent>,
   }
  });
 
 